export const MODIFICATION_ID = "modificationId";
export const STACK_ID = "stackId";
export const VERSION_ID = "versionId";
export const PROJECT_ID = "projectId";
export const COMPARATOR_VERSION_ID = "comparatorVersionId";
export const COMPARATOR_PROJECT_ID = "comparatorProjectId";

export const SOURCE_PROJECT_ID = "sourceProjectId";
export const SOURCE_MODIFICATION_ID = "sourceModificationId";
